import { CareerPathScoreSection, ColorToken } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

type CareerPathsCardProps = Readonly<{
  careerPathSuggestions: CareerPathWithScore[];
}>;

const FIT_COLORS: Record<CareerPathScoreSection, ColorToken> = {
  TOP: 'Brand/700',
  MIDDLE: 'Brand/500',
  LOW: 'Brand/200',
};

export function CareerPathsCard({ careerPathSuggestions }: CareerPathsCardProps) {
  return (
    <Box sx={containerSx}>
      {careerPathSuggestions.map((path) => (
        <Box key={path.careerPath.id} sx={dotSx(FIT_COLORS[path.scoreSection] ?? FIT_COLORS.LOW)} />
      ))}
    </Box>
  );
}

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-sm'],
});

const dotSx =
  (colorToken: ColorToken): SxProps<Theme> =>
  ({ backrs }) => ({
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: backrs.colors[colorToken],
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  });
